import React, { useContext } from 'react';
import { GenericSquare } from '../../generic/square';
import { COLORS } from '../../constants';
import { LabelWithIcon } from '../../generic/label-with-icon';
import { ComponentContext } from '../../contexts/components-context';
export var Rectangle = function (_a) {
    var definition = _a.definition;
    var width = definition.width, height = definition.height, text = definition.text, icon = definition.icon;
    var SelectionMarker = useContext(ComponentContext).SelectionMarker;
    return (React.createElement("svg", { style: { pointerEvents: 'all' } },
        React.createElement(GenericSquare, { width: width, height: height, stroke: definition.strokeColor || COLORS.DEFAULT_STROKE, fill: definition.fillColor || COLORS.DEFAULT_FILL, notBounding: true }),
        text || icon ? React.createElement(LabelWithIcon, { definition: definition }) : null,
        React.createElement(SelectionMarker, { width: width, height: height })));
};
//# sourceMappingURL=rectangle.js.map